<template>
  <transition name="cycleFromLeft" mode="out-in">
    <div class="range vh-for-mobile" :data-variant="variant">

      <div class="wrapper">

        <div class="wrapper__left">

          <div v-if="config.shortText" class="question__shortText" v-html="config.shortText"></div>

          <div v-if="config.image" class="range__image">
            <img :src="getImagePath" :alt="config.shortText"/>
          </div>

          <div v-if="config.fullText" class="range__fullText" v-html="config.fullText"></div>

          <div v-if="hasOverlay"
               class="question__info hidden-xs"
               @click="openInfoOverlay">
            <img :src="returnBasePath('/assets/img/shared/icon-help.png')" alt="Info"/>
            <span>{{config.info.label}}</span>
          </div>

        </div>

        <div class="wrapper__right">

          <transition name="slideLeft" mode="out-in">
            <div v-if="config.answers"
                 class="range__answers">

              <!-- RANGE SLIDER -->
              <div class="range__slider">
                <div class="range__image">
                  <img :src="getImagePath" alt=""/>
                </div>
                <vue-slider v-bind="options" ref="slider" v-model="currentValue"></vue-slider>
                <div class="range__icon">
                  <img :src="returnBasePath('/assets/img/shared/icon-drag.png')" alt=""/>
                </div>
              </div>

              <div class="range__confirm" @click="submitValue">
                <span class="range__confirm__span">conferma e continua</span>
              </div>
            </div>
          </transition>

          <div v-if="hasOverlay"
               class="question__info visible-xs"
               @click="openInfoOverlay">
            <img :src="returnBasePath('/assets/img/shared/icon-help.png')" alt="Info"/>
            <span>{{config.info.label}}</span>
          </div>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
  import vueSlider from 'vue-slider-component';

  export default{
    props: ['dataObj', 'currentVariant'],
    data(){
      return {
        config: {},
        variant: this.currentVariant,
        hasInfo: false,
        currentValue: 1,
        isIE: false,
        options: {
          value: 1,
          width: 240,
          height: 8,
          dotSize: 20,
          min: 1,
          max: 7,
          interval: 1,
          disabled: false,
          show: true,
          speed: 0.45,
          reverse: false,
          lazy: true,
          tooltip: 'always',
          piecewise: false
        }
      }
    },
    watch: {
      currentVariant(){
        this.variant = this.currentVariant;
      }
    },
    components: {
      vueSlider
    },
    computed: {
      getAnswerLabel(){
        return this.config.answers[this.currentValue - 1].text;
      },
      getImagePath(){
        var val = this.currentValue;
        if (this.currentValue == '7+') {
          val = 7;
        }
        return this.config.answers[val - 1].image;
      },
      getInputId(){
        return 'range-' + this.config.id;
      },
      getAnswersLength(){
        return this.config.answers.length;
      },
      hasOverlay(){
        return this.config.info && this.config.info.type == 'overlay';
      }
    },
    methods: {
      getThumbPosition(){

      },
      checkIfOverflow(){
        var viewHeight = $('.range').innerHeight();
        var windowHeight = $(window).innerHeight();
        var footerHeight = $('.footer').innerHeight();
        var headerHeight = $('.header').innerHeight();
        var visibleHeight = windowHeight - footerHeight - headerHeight;
        if (viewHeight > visibleHeight) {
          $('.range').addClass('has-overflow');
        }
      },
      checkValue(idx){
        console.log(this.currentValue);
        var percentage = 100 / (this.config.answers.length - 1);
        percentage = percentage * (this.currentValue - 1);
        $('.range__custom__thumb').css('left', (percentage) + '%');
        return idx == (this.currentValue - 1);
      },
      getLeft(idx){
        return ((100 / this.config.answers.length) * idx) + '%';
      },
      getLeftMargin(idx){
        return ((idx * 2) - 1 ) + 'px';
      },
      openInfoOverlay(){
        var vm = this;
        if (vm.config.info.type == 'overlay') {
          vm.$emit('open-overlay', vm.config.info);
        }
      },
      beforeEnter(){
        $('.range__answers__item').addClass('slideLeft-enter');
      },
      enter(){
        $('.range__answers__item').removeClass('slideLeft-enter');
      },
      leave(){
      },
      afterLeave(){
      },
      submitValue(){
        var vm = this;
        vm.retrieveNextStep(vm.config.id, vm.config.answers[vm.currentValue - 1].id, false);
      },
      updateProps(){
        //Update component data when component is mounted or updated
        this.config = this.dataObj;
      },
      updateParentProps(){
        // Emits response from @retrieveNextStep(), precedently saved in Vue store, to parent component @App.vue
        var vm = this;
        var config = vm.$store.state.tempConfigObj;
        if (config) {
          vm.$emit('update-props', config);
          this.$forceUpdate();
        }
      },
      retrieveNextStep(rangeId, answerId, isDisabled){
        if (!isDisabled) {
          // Make AJAX call to retrieve next range node
          // @rangeId {integer}:
          //    is the current node ID
          // @answerId {integer}:
          //    is the chosen answer ID
          var vm = this;
          $('.range__confirm').addClass('is-disabled');
          vm.makeNextCall(rangeId, answerId, function () {
            vm.updateParentProps();
          })
        }
      },
      initSlider(){
        var vm = this;
        var min = 1;
        var max = vm.config.answers.length;
        var data = [];

        for (var i = 0; i < max; i++) {
          data.push(vm.config.answers[i].text);
        }

        vm.options = {
          value: 1,
          width: 240,
          height: 8,
          min: min,
          max: 7,
          speed: 0.45,
          lazy: false,
          data: data
        }
      }
    },
    mounted(){
      var vm = this;
      vm.updateProps();
      console.log(vm.config);
      this.initSlider();
    },
    updated(){
      var vm = this;
      vm.updateProps();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/range/Range.vue